<template>
  <section class="container-fluid">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />Horarios asignados
              <div class="row">
                <div class="col-12 col-xl-6"></div>
                <div class="col-12 col-xl-6">
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="form-group">
                        <label class="control-label" for="courses_offered_year"
                          >Gestión:</label
                        >
                        <b-form-select
                          v-model="columnFilter.courses_offered_year"
                          :options="coursesOfferedYearsOptions"
                          id="courses_offered_year"
                          size="sm"
                          @change="filterTable"
                        >
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="form-group">
                        <label class="control-label" for="period"
                          >Periodo:</label
                        >
                        <b-form-select
                          v-model="columnFilter.period"
                          :options="periodOptions"
                          value-field="value"
                          text-field="name"
                          id="period"
                          size="sm"
                          @change="filterTable"
                        >
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="table-bordered c-table c-table-main"
              :bordered="true"
              :small="true"
              :items="items"
              :fields="fields"
              :sorter="{ external: true, resetable: true }"
              @update:sorter-value="filterTable"
              :columnFilter="{ external: true, lazy: true }"
              @update:column-filter-value="filterTable"
              :column-filter-value.sync="columnFilter"
              :loading="loading"
            >
              <template #no-items-view>
                <div class="no-items-view">
                  {{
                    loading
                      ? "Cargando datos..."
                      : "No existen horarios asignados"
                  }}
                  <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                </div>
              </template>
              <!-- filters -->
              <!-- data -->
              <template #course="{ item }">
                <table class="table table-bordered" style="margin-bottom: 7px">
                  <thead style="background: #ced2d8">
                    <tr>
                      <th colspan="2">
                        {{ item.course_name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td width="50%">
                        <b>Tipo de curso: </b
                        >{{ item.type_of_course | type_of_course }}
                      </td>
                      <td width="50%">
                        <b>Nro de Aula: </b>{{ item.classroom }}
                      </td>
                    </tr>
                    <tr>
                      <td width="50%" >
                        <span style="white-space: pre">{{
                          item | time_courses_offered
                        }}</span>
                      </td>
                      <td width="50%">
                        <b>Paralelo: </b>{{ item.parallel != 'NONE' ? item.parallel : 'NONE'  }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </CDataTable>
          </CCardBody>
          <div>
            <CPagination
              :activePage.sync="page"
              :pages="pages"
              size="sm"
              align="center"
              @update:activePage="updateTable"
            />
            <TableRecords
              :total="total"
              :loading="loading"
              :from="from"
              :to="to"
              :page="page"
            />
          </div>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import {
  BAlert,
  BModal,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import CoursesOffered from "@/plugins/services/courses-offered";
import Syllabus from "@/plugins/services/syllabus";

export default {
  name: "TeacherScheduleList",
  components: {
    BAlert,
    BModal,
    BButton,
    BButtonGroup,
    TableRecords,
    BFormSelect,
    BFormSelectOption,
  },
  data() {
    return {
      fields: [
        {
          key: "course",
          label: "Horarios",
          filter: false,
          sorter: false,
        },
      ],
      items: [],
      columnFilter: { column: null, asc: false, enabled: true },
      coursesOfferedYearsOptions: [],
      periodOptions: Constants.periodOptions,
      typeOfCourseOptions: Constants.typeOfCourseOptions,
      enabledOptions: Constants.enabledOptions,
      syllabusOptions: [],
      page: 0,
      pages: 0,
      limit: 10,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      dataEmit: { modalShow: false, data: null },
    };
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  created() {
    this.columnFilter.courses_offered_year = Utils.getYear(this.userAuth.now);
    this.columnFilter.person_id = this.userAuth.person_id;
    this.getAll(this.columnFilter);
    this.getCoursesOfferedYears();
    this.getSyllabus();
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Utils.columnFilter("courses-offered", q);
      CoursesOffered.indexSchedule(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        column: null,
        asc: false,
        enabled: true,
        courses_offered_year: Utils.getYear(this.userAuth.now),
        person_id: this.userAuth.person_id,
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter);
    },
    getCoursesOfferedYears() {
      this.coursesOfferedYearsOptions = Utils.getYears(this.userAuth.now);
    },
    // search Syllabus
    getSyllabus() {
      Syllabus.selectAll()
        .then((res) => {
          this.syllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
